module.exports = __webpack_public_path__ + "public-ui/img/alef.45b4b422.svg";